import {evaluateQuizData} from "../actions/crud/evaluateQuizData";
import {restartQuizTrigger} from "../components/restartQuizTrigger";

/**
 * Show success question
 */
document.addEventListener('growtypeQuizShowSuccessQuestion', showSuccessQuestionListener)

function showSuccessQuestionListener(params) {
    let quizWrapper = $(params['detail']['currentQuestion']).closest('.growtype-quiz-wrapper');

    /**
     * Check if success page event was fired and quiz is finished
     */
    evaluateQuizData(quizWrapper);

    let question = quizWrapper.find('.growtype-quiz-question');

    if (params.detail && params.detail.currentQuestion) {
        question = $(params.detail.currentQuestion);
    }

    let successQuestion = params.detail && params.detail.nextQuestion
        ? $(params.detail.nextQuestion)
        : $();

    if (!successQuestion.length || successQuestion.attr('data-question-type') !== 'success') {
        successQuestion = quizWrapper.find('.growtype-quiz-question[data-question-type="success"]').first();
    }

    quizWrapper
        .find('.growtype-quiz-question[data-question-type="success"]')
        .not(successQuestion)
        .removeClass('is-active')
        .hide();

    question
        .removeClass('is-active')
        .hide()
        .promise()
        .done(function () {
            $('body').attr('data-current-question-type', 'success')
            successQuestion.fadeIn().addClass('is-active');

            restartQuizTrigger(quizWrapper);
        });
}
